export default __webpack_public_path__ + "static/media/Ubuntu-Bold.fec2d0f1.ttf";